import type { QueryScreenState } from 'src/utils/requestError';

import { isOnline } from 'src/utils/online';
import { queryScreenState } from 'src/utils/requestError';

/** The slice of a TanStack query result the screen-state decision reads. */
export interface QueryScreenSource {
  isLoading: boolean;
  isFetching: boolean;
  isPaused: boolean;
  isError: boolean;
  error: unknown;
  data: unknown;
}

/**
 * Loading / an explained failure / ready, for one query, in one place — so every public screen
 * that fetches something reads it the same way (`Home`, the rentals feed, both listing screens),
 * and a screen that still branches on `isLoading` and `data` alone can adopt it in one line.
 */
export const useQueryScreenState = (query: QueryScreenSource): QueryScreenState =>
  queryScreenState({
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isPaused: query.isPaused,
    isError: query.isError,
    error: query.error,
    hasData: query.data !== undefined,
    online: isOnline(),
  });
